module.exports = __webpack_public_path__ + "img/stacked.83759855.svg";